import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Card from '@material-ui/core/Card';
import { createStructuredSelector } from 'reselect';
import { withStyles } from '@material-ui/core/styles';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import styles from './styles';
import {
  selectBusinessAttributes,
  selectUserAttributes,
} from '../../../store/selectors';
import BuilderProfileBusinessForm from './BuilderProfileBusinessForm';
import { SERVICE_AREAS } from '../../../constants';

const propTypes = {
  classes: PropTypes.shape({
    heading: PropTypes.string,
  }).isRequired,
  userAttributes: PropTypes.shape({
    'custom:buildingLicNo': PropTypes.string,
    'custom:businessAddress': PropTypes.string,
    'custom:businessName': PropTypes.string,
    'custom:personalEmail': PropTypes.string,
    'custom:personalPhone': PropTypes.string,
    'custom:mobileNumber': PropTypes.string,
    'custom:position': PropTypes.string,
    'custom:profileHeadline': PropTypes.string,
    'custom:serviceAState': PropTypes.string,
    'custom:serviceAType': PropTypes.string,
    'custom:skillsetBuild': PropTypes.string,
    'custom:skillsetLook': PropTypes.string,
    email: PropTypes.string,
    email_verified: PropTypes.string,
    name: PropTypes.string,
    sub: PropTypes.string,
  }).isRequired,
  businessAttributes: PropTypes.shape({
    businessNumber: PropTypes.string,
    businessName: PropTypes.string,
    businessMailingAddress: PropTypes.string,
    businessDescription: PropTypes.string,
    businessPhoneNumber: PropTypes.string,
    businessServiceAreaAddress: PropTypes.string,
    businessServiceAreaCoordinates: PropTypes.string,
    businessSkillsetBuild: PropTypes.string,
    businessSkillsetLook: PropTypes.string,
    businessPosition: PropTypes.string,
    businessApproved: PropTypes.bool,
    businessServiceAreaState: PropTypes.string,
    businessServiceAreaType: PropTypes.oneOf([
      SERVICE_AREAS.LOCAL,
      SERVICE_AREAS.NATIONAL,
      SERVICE_AREAS.STATEWIDE,
    ]),
  }).isRequired,
  enableEditing: PropTypes.bool.isRequired,
};

export const BuilderProfileBusinessContainer = props => {
  const { classes, businessAttributes, userAttributes, enableEditing } = props;
  // console.log(
  //   '🚀 ~ file: index.js ~ line 64 ~ businessAttributes',
  //   businessAttributes,
  // );

  const getInitialFormValues = () => ({
    businessNumber: userAttributes.sub,
    businessPhoneNumber:
      userAttributes['custom:mobileNumber'] ||
      userAttributes['custom:personalPhone'],
    businessName: businessAttributes.businessName,
    businessPosition: businessAttributes.businessPosition,
    businessDescription: businessAttributes.businessDescription,
    businessMailingAddress: businessAttributes.businessMailingAddress,
    businessSkillsetBuild: businessAttributes.businessSkillsetBuild,
    businessSkillsetLook: businessAttributes.businessSkillsetLook,
    materialLocation: businessAttributes.materialLocation,
    postcode: userAttributes['custom:postcode'],
    roleType: userAttributes['custom:roleType'],
    logoImage: businessAttributes.logo,
    coverPhotoImage: businessAttributes.coverPhoto,
    galleryImages: businessAttributes.gallery,
    googlePlaceField: businessAttributes.googlePlaceField,
    googlePlaceId: businessAttributes.googlePlaceId,
  });

  return (
    <Card className={classes.cardRoot}>
      <CardHeader
        classes={{
          root: classes.cardHeaderRoot,
          title: classes.cardHeaderTitle,
        }}
        title="Business Details"
      />
      <CardContent
        classes={{
          root: classes.cardContentRoot,
        }}
      >
        <BuilderProfileBusinessForm
          initialValues={getInitialFormValues()}
          isBuilder={userAttributes['custom:roleType'] === 'B'}
          enableReinitialize
          enableEditing={enableEditing}
        />
      </CardContent>
    </Card>
  );
};

BuilderProfileBusinessContainer.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({
  userAttributes: selectUserAttributes(),
  businessAttributes: selectBusinessAttributes(),
});

export default withStyles(styles)(
  connect(mapStateToProps)(BuilderProfileBusinessContainer),
);
